import apibase from './BaseAPI';

const getRecordsWithTimeframe = async (params) => {
    try {
        const res = await apibase.post('/openai/getRecordsWithTimeframe', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const getAgents = async (params) => {
    try {
        const res = await apibase.post('/openai/getIprofAgents', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const getChatlogs = async (params) => {
    try {
        const res = await apibase.post('/openai/getAgentChatlogWithTimeframe', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const checkKey = async (params) => {
    try {
        const res = await apibase.post('/userBinding/validateKey', params)
        return res.data

    } catch (err) {
        if (err.response?.status === 422) {
            console.error("Unprocessable Entity: Missing or invalid access key.");
        }
        else {
            throw err
        }
    }
}

export default {
    getRecordsWithTimeframe: getRecordsWithTimeframe,
    getAgents: getAgents,
    getChatlogs: getChatlogs,
    checkKey: checkKey,
}